export default "__VITE_ASSET__0add0c32__"